import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    mvdTable: null,
    error: null,
    loading: false
};

const mvdTableSlice = createSlice({
    name: 'mvdTable',
    initialState,
    reducers: {
        setMvdTable: (state, action) => {
            state.mvdTable = action.payload;
        },
        clearMvdTable: (state) => {
            state.mvdTable = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const {
    setMvdTable,
    clearMvdTable,
    setError,
    setLoading
} = mvdTableSlice.actions;

export default mvdTableSlice.reducer;